import React, { useState } from "react";

const List = ({ items, isList }) => (
  <>
    {isList ? (
      <ul className="listTool" contentEditable>
        {items && items.length > 0 ? (
          items.map((item, index) => <li key={index}>{item}</li>)
        ) : (
          <li>Nuevo ítem</li>
        )}
      </ul>
    ) : (
      <div className="noteTool" contentEditable>
        {items}
      </div>
    )}
  </>
);

export const editItems = [
  {
    id: "List",
    content: <List />,
    isComponent: true,
    label: "List",
    logo: "List",
    x: 0,
    y: 0,
  },
  {
    id: "BulletList",
    content: <List />,
    isComponent: true,
    label: "BulletList",
    logo: "BulletList",
    x: 0,
    y: 0,
  },
  {
    id: "NumberList",
    content: <List />,
    isComponent: true,
    label: "NumberList",
    logo: "NumberList",
    x: 0,
    y: 0,
  },
];
